import React from "react";
import { View, Text } from "@react-pdf/renderer";

export default function EmisorSection({ S, data }) {
  return (
    <View style={[S.box, { height: "auto" }]}>
      <Text style={S.label}>Datos del Emisor</Text>

      <View
        style={{
          flexDirection: "row",
          flexWrap: "wrap",
          marginTop: 6,
        }}
      >
        <Text style={{ marginRight: 10 }}>
          <Text style={S.bold}>Emisor:</Text> {data.emisor}  
        </Text>

        <Text style={{ marginRight: 10 }}>
          <Text style={S.bold}>RUC:  </Text> {data.emisorRuc}
        </Text>

        <Text style={{ marginRight: 10 }}>
          <Text style={S.bold}>DV: </Text> {data.emisorDv} 
        </Text>

        <Text style={{ marginRight: 10 }}>
          <Text style={S.bold}>Dirección: </Text> {data.emisorDireccion}
        </Text>
      </View>
    </View>
  );
}